/* Native vervanging voor de Globo-opties: kalender, leverdatum met toeslagen en aantal bij de prijs.
   v4 (2026-10-08): het blok Production time is een keuze voor de leverdatum geworden.
   Rush Processing en Shipping Upgrade zijn toeslagen die een keer per order in de
   winkelwagen komen; een nieuwe keuze vervangt de oude. Rush kan niet samen met
   Paper Plates of Bar sign in een order: dan verdwijnen de rush-opties.
   v4.1 (2026-10-09): het hoofdproduct gaat als FormData naar de winkelwagen, zodat
   geuploade bestanden meekomen (zie submitWithAddons). */
(function () {
  'use strict';

  var DAY = 86400000;
  var EVENTS = ['change', 'input', 'variant:update', 'variantChange', 'on:variant:change'];
  var NO_RUSH_TYPES = ['Paper Plates', 'Bar sign'];

  function startOfDay(d) { var c = new Date(d); c.setHours(0, 0, 0, 0); return c; }
  function addDays(d, n) { return new Date(d.getTime() + n * DAY); }
  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }
  function cartForm() { return document.querySelector('form[action*="/cart/add"]'); }
  function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function toNumber(value) {
    if (value == null) return null;
    var m = String(value).match(/(\d[\d.,]*)/);
    if (!m) return null;
    var n = parseInt(m[1].replace(/[.,]/g, ''), 10);
    return n > 0 ? n : null;
  }

  /* ---------- Aantal naast de prijs ---------- */
  if (!customElements.get('selected-quantity')) {
    class SelectedQuantity extends HTMLElement {
      connectedCallback() {
        this.out = this.querySelector('[data-quantity-output]');
        this.fallback = parseInt(this.dataset.defaultQuantity, 10) || 50;
        this.unit = this.dataset.unit || '';
        try { this.map = JSON.parse(this.querySelector('[data-quantity-map]').textContent); }
        catch (e) { this.map = {}; }

        this.handler = this.update.bind(this);
        var self = this;
        EVENTS.forEach(function (n) { document.addEventListener(n, self.handler); });
        this.observer = new MutationObserver(this.handler);
        this.observer.observe(cartForm() || document.body, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['value', 'checked', 'aria-checked', 'selected']
        });
        this.update();
      }

      disconnectedCallback() {
        var self = this;
        EVENTS.forEach(function (n) { document.removeEventListener(n, self.handler); });
        if (this.observer) this.observer.disconnect();
      }

      update() {
        if (!this.out) return;
        var form = cartForm();
        var field = form ? form.querySelector('[name="id"]') : null;
        var amount = field ? toNumber(this.map[field.value]) : null;
        if (!amount) amount = this.fallback;
        var locale = document.documentElement.lang || 'en';
        var text = this.unit ? amount.toLocaleString(locale) + ' ' + this.unit : String(amount);
        if (this.out.textContent.trim() !== text) this.out.textContent = text;
      }
    }
    customElements.define('selected-quantity', SelectedQuantity);
  }

  /* ---------- Kalender ---------- */
  if (!customElements.get('date-field')) {
    class DateField extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-date-trigger]');
        this.display = this.querySelector('[data-date-display]');
        this.value = this.querySelector('[data-date-value]');
        this.calendar = this.querySelector('[data-date-calendar]');
        if (!this.trigger || !this.calendar) return;

        this.placeholder = this.display.textContent.trim();
        this.locale = this.dataset.locale || 'en';
        this.min = addDays(startOfDay(new Date()), parseInt(this.dataset.minDays, 10) || 0);
        this.max = new Date(this.min);
        this.max.setMonth(this.max.getMonth() + (parseInt(this.dataset.maxMonths, 10) || 12));
        this.selected = null;
        this.focused = new Date(this.min);
        this.view = new Date(this.min.getFullYear(), this.min.getMonth(), 1);

        this.onOutside = this.onOutside.bind(this);
        this.onKey = this.onKey.bind(this);
        this.trigger.addEventListener('click', this.toggle.bind(this));
        this.calendar.addEventListener('click', this.onClick.bind(this));
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }

      get open() { return !this.calendar.hidden; }

      toggle() { this.open ? this.close() : this.show(); }

      show() {
        this.calendar.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        var self = this;
        setTimeout(function () {
          document.addEventListener('click', self.onOutside);
          document.addEventListener('keydown', self.onKey);
        }, 0);
        this.render();
      }

      close() {
        this.calendar.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }

      onOutside(event) { if (!this.contains(event.target)) this.close(); }

      onKey(event) {
        var steps = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 };
        if (event.key === 'Escape') { this.close(); this.trigger.focus(); return; }
        if (steps[event.key] !== undefined) {
          event.preventDefault();
          var next = addDays(this.focused, steps[event.key]);
          if (next >= this.min && next <= this.max) {
            this.focused = next;
            this.view = new Date(next.getFullYear(), next.getMonth(), 1);
            this.render();
            var cell = this.calendar.querySelector('[data-focused]');
            if (cell) cell.focus();
          }
        }
      }

      onClick(event) {
        var nav = event.target.closest('[data-nav]');
        if (nav) {
          this.view.setMonth(this.view.getMonth() + parseInt(nav.dataset.nav, 10));
          this.render();
          return;
        }
        if (event.target.closest('[data-clear]')) { this.clear(); return; }
        if (event.target.closest('[data-close]')) { this.close(); this.trigger.focus(); return; }
        var day = event.target.closest('[data-day]:not([disabled])');
        if (day) this.select(new Date(day.dataset.day));
      }

      select(date) {
        this.selected = startOfDay(date);
        this.focused = new Date(this.selected);
        this.value.value = this.selected.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        this.display.textContent = this.selected.toLocaleDateString(this.locale, { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' });
        this.classList.add('date-field--filled');
        this.removeAttribute('data-invalid');
        this.close();
        this.trigger.focus();
      }

      clear() {
        this.selected = null;
        this.value.value = '';
        this.display.textContent = this.placeholder;
        this.classList.remove('date-field--filled');
        this.render();
      }

      weekdays() {
        var labels = [];
        var sunday = new Date(2024, 8, 1);
        for (var i = 0; i < 7; i++) {
          labels.push(addDays(sunday, i).toLocaleDateString(this.locale, { weekday: 'short' }).slice(0, 2));
        }
        return labels;
      }

      render() {
        var year = this.view.getFullYear();
        var month = this.view.getMonth();
        var first = new Date(year, month, 1);
        var gridStart = addDays(first, -first.getDay());
        var today = startOfDay(new Date());
        var cells = '';

        for (var i = 0; i < 42; i++) {
          var day = addDays(gridStart, i);
          var outside = day.getMonth() !== month;
          var disabled = day < this.min || day > this.max;
          var picked = this.selected && sameDay(day, this.selected);
          cells += '<button type="button" class="date-field__day' +
            (outside ? ' date-field__day--outside' : '') +
            (picked ? ' date-field__day--selected' : '') +
            '" data-day="' + day.toISOString() + '"' +
            (disabled ? ' disabled' : '') +
            (sameDay(day, this.focused) ? ' data-focused tabindex="0"' : ' tabindex="-1"') +
            (sameDay(day, today) ? ' data-today' : '') +
            '>' + day.getDate() + '</button>';
        }

        this.calendar.innerHTML =
          '<div class="date-field__header">' +
            '<button type="button" class="date-field__nav" data-nav="-12" aria-label="Previous year">&laquo;</button>' +
            '<button type="button" class="date-field__nav" data-nav="-1" aria-label="Previous month">&lsaquo;</button>' +
            '<span class="date-field__title" aria-live="polite">' + this.view.toLocaleDateString(this.locale, { month: 'long' }) + ' ' + year + '</span>' +
            '<button type="button" class="date-field__nav" data-nav="1" aria-label="Next month">&rsaquo;</button>' +
            '<button type="button" class="date-field__nav" data-nav="12" aria-label="Next year">&raquo;</button>' +
          '</div>' +
          '<div class="date-field__weekdays">' + this.weekdays().map(function (l) { return '<span>' + l + '</span>'; }).join('') + '</div>' +
          '<div class="date-field__grid">' + cells + '</div>' +
          '<div class="date-field__actions">' +
            '<button type="button" class="date-field__action" data-clear>Clear</button>' +
            '<button type="button" class="date-field__action" data-close>Close</button>' +
          '</div>';
      }
    }
    customElements.define('date-field', DateField);
  }

  /* ---------- Leverdatum + toeslagen, een keer per order (v4, 2026-10-08) ----------
     Het select [data-delivery] heeft per optie data-addons (variant-id's van Rush
     Processing en/of Shipping Upgrade), data-ship-days en data-rush. De datum =
     morgen (proof goedgekeurd, Central Time) + productie + verzending in
     werkdagen, zonder weekenden en UPS-feestdagen. De langste productietijd in de
     winkelwagen telt, want alles gaat samen de deur uit.
     Bij toevoegen: oude toeslagen die niet bij de nieuwe keuze horen gaan eruit,
     ontbrekende komen erbij. Zo betaalt de klant elke toeslag hooguit een keer.
     Onder het select verschijnt alleen een regel als er al een toeslag in de
     winkelwagen zit; de vaste uitleg staat in het blok zelf. */
  var PRODUCTION = { 'Napkins': 4, 'Coasters': 4, 'Paper Plates': 4, 'Can Coolers': 4, 'Bar sign': 5, 'Stickers': 3 };
  var RUSH_DAYS = 2;
  var HOLIDAYS = ['2026-11-26', '2026-12-25', '2027-01-01', '2027-05-31', '2027-07-05', '2027-09-06', '2027-11-25', '2027-12-24'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function workday(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function addWorkdays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); if (workday(d)) n--; }
    return d;
  }
  function approvalDay() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var now = new Date(); parts = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    }
    return new Date(+parts.year, +parts.month - 1, +parts.day + 1);
  }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }

  function rushSelect() { return document.querySelector('[data-rush-select]'); }
  function summaryNode() { return document.querySelector('[data-rush-summary]'); }

  function showSummary(text, warning) {
    var summary = summaryNode();
    if (!summary) return;
    summary.textContent = text;
    summary.hidden = !text;
    if (warning) summary.setAttribute('data-warning', ''); else summary.removeAttribute('data-warning');
  }

  function upgradeIds(select) { return (select.dataset.upgradeIds || '').split(',').filter(Boolean); }
  function addonsOf(option) { return option ? (option.dataset.addons || '').split(',').filter(Boolean) : []; }
  function sameSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function (x) { return b.indexOf(x) !== -1; });
  }

  var cartState = { items: [], upgrades: [] };

  function fetchCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; });
  }

  function readCart(select, cart) {
    var ids = upgradeIds(select);
    var items = cart.items || [];
    cartState.items = items.filter(function (i) { return ids.indexOf(String(i.variant_id)) === -1; });
    cartState.upgrades = items
      .filter(function (i) { return ids.indexOf(String(i.variant_id)) !== -1; })
      .map(function (i) { return String(i.variant_id); });
  }

  function cartBlocksRush() {
    return cartState.items.some(function (i) { return NO_RUSH_TYPES.indexOf(i.product_type) !== -1; });
  }

  function decorate(select) {
    var prodMax = parseInt(select.dataset.prodMax, 10) || 4;
    cartState.items.forEach(function (i) {
      var p = PRODUCTION[i.product_type];
      if (p && p > prodMax) prodMax = p;
    });
    var noRush = select.dataset.rushAllowed !== 'true' || cartBlocksRush();
    var approve = approvalDay();

    Array.prototype.slice.call(select.options).forEach(function (option) {
      if (!option.dataset.key) return;
      if (option.dataset.rush && noRush) { option.remove(); return; }
      var days = (option.dataset.rush ? RUSH_DAYS : prodMax) + parseInt(option.dataset.shipDays, 10);
      var date = fmtDate(addWorkdays(approve, days));
      var price = parseInt(option.dataset.price, 10) || 0;
      option.textContent = date + ': ' + option.dataset.label + (price > 0 ? ' (+' + money(price) + ')' : '');
      option.value = option.dataset.label + ', arrives by ' + date;
    });

    if (cartState.upgrades.length && !select.dataset.touched) {
      var match = Array.prototype.slice.call(select.options).filter(function (o) {
        return o.dataset.key && sameSet(addonsOf(o), cartState.upgrades);
      })[0];
      if (!match) {
        // bv. rush in de winkelwagen maar dit product kan geen rush: pak dezelfde verzending
        var shipOnly = cartState.upgrades.filter(function (id) {
          return Array.prototype.slice.call(select.options).some(function (o) { return sameSet(addonsOf(o), [id]); });
        });
        match = Array.prototype.slice.call(select.options).filter(function (o) {
          return o.dataset.key && sameSet(addonsOf(o), shipOnly);
        })[0];
      }
      if (match) match.selected = true;
    }
    refresh();
  }

  function refresh() {
    var select = rushSelect();
    if (!select) return;
    var option = select.options[select.selectedIndex];
    if (!option || !option.dataset.key || !cartState.upgrades.length) { showSummary('', false); return; }
    var chosen = addonsOf(option);

    if (sameSet(chosen, cartState.upgrades)) {
      showSummary('Already in your order, no extra charge for this item.', false);
    } else if (!chosen.length) {
      showSummary('This changes your whole order back to standard delivery.', false);
    } else {
      showSummary('This replaces the delivery option already in your order and applies to everything in it.', false);
    }
  }

  function valid() {
    var ok = true;
    document.querySelectorAll('[data-addon-required]').forEach(function (field) {
      var host = field.closest('date-field') || field;
      if (!field.value || !field.value.trim()) {
        ok = false;
        host.setAttribute('data-invalid', '');
      } else {
        host.removeAttribute('data-invalid');
      }
    });
    return ok;
  }

  function init() {
    var select = rushSelect();
    if (!select || select.dataset.addonsReady) return;
    select.dataset.addonsReady = 'true';
    select.addEventListener('change', function () {
      select.dataset.touched = 'true';
      select.removeAttribute('data-invalid');
      refresh();
    });
    if (select.hasAttribute('data-delivery')) {
      decorate(select);
      fetchCart().then(function (cart) { readCart(select, cart); decorate(select); });
      document.addEventListener('cart:update', function (e) {
        if (e.detail && e.detail.source === 'product-addons') return;
        fetchCart().then(function (cart) { readCart(select, cart); decorate(select); });
      });
    } else {
      refresh();
    }
  }

  /*
   * Horizon (assets/component.js) vangt submit af met een capture-listener op
   * document en voegt het product dan zelf toe. Window-capture draait daarvoor,
   * dus hier kunnen we Horizon tegenhouden als er toeslagen bij moeten.
   */
  if (!window.__ypdAddonsSubmit) {
    window.__ypdAddonsSubmit = true;
    window.addEventListener('submit', function (event) {
      if (typeof window.ypdNapkinApply === 'function') { try { window.ypdNapkinApply(); } catch (e) {} }
      var form = cartForm();
      if (!form || event.target !== form) return;

      if (!valid()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var bad = document.querySelector('[data-invalid] [data-date-trigger]');
        if (bad) bad.focus();
        return;
      }

      var select = rushSelect();
      if (!select || !select.hasAttribute('data-delivery')) return;
      var option = select.options[select.selectedIndex];
      var chosen = addonsOf(option);
      if (!chosen.length && !cartState.upgrades.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      submitWithAddons(form, select, chosen);
    }, true);
  }

  var busy = false;

  /*
   * HET HOOFDPRODUCT GAAT ALS FORMDATA, NIET ALS JSON (2026-10-09).
   * In JSON wordt een gekozen bestand een leeg object: order #1003 kwam binnen
   * met Image t/m Image 5 = "{}" en zonder foto's. cart/add.js neemt multipart
   * FormData aan, net als het gewone formulier, en zet geuploade bestanden dan
   * op de CDN. Lege tekstvelden en lege uploadslots gaan er vooraf uit, zodat er
   * geen lege regels op de order staan. De toeslagen gaan daarna apart als JSON.
   */
  function submitWithAddons(form, select, chosen) {
    if (busy) return;
    busy = true;
    if (typeof window.ypdNapkinApply === 'function') { try { window.ypdNapkinApply(); } catch (e) {} }

    var data = new FormData(form);
    var drop = [];
    data.forEach(function (value, key) {
      if (!/^properties\[/.test(key)) return;
      var empty = typeof value === 'string' ? !value : !(value && value.size);
      if (empty && drop.indexOf(key) === -1) drop.push(key);
    });
    drop.forEach(function (key) { data.delete(key); });

    var button = form.querySelector('[type="submit"], button[name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');
    function done() { busy = false; if (button) button.removeAttribute('aria-busy'); }

    var option = select.options[select.selectedIndex];
    var mainAdded = false;
    fetchCart().then(function (cart) {
      readCart(select, cart);
      if (option && option.dataset.rush && cartBlocksRush()) {
        showSummary('Rush production isn\'t possible in an order with paper plates or signs. Please pick a shipping option without Rush production.', true);
        done();
        return null;
      }
      var updates = {};
      var toRemove = cartState.upgrades.filter(function (id) { return chosen.indexOf(id) === -1; });
      toRemove.forEach(function (id) { updates[id] = 0; });
      var toAdd = chosen.filter(function (id) { return cartState.upgrades.indexOf(id) === -1; });

      var first = toRemove.length
        ? fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
        : Promise.resolve();

      return first
        .then(function () {
          return fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); mainAdded = true; return r.json(); })
        .then(function () {
          if (!toAdd.length) return null;
          return fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: toAdd.map(function (id) { return { id: id, quantity: 1 }; }) })
          });
        })
        .then(function () {
          cartState.upgrades = chosen.slice();
          refresh();
          ['cart:update', 'cart:refresh'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'product-addons' } }));
          });
        })
        .catch(function () { if (!mainAdded) form.submit(); })
        .finally(done);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-addon-help-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
